import { render, staticRenderFns } from "./_document.vue?vue&type=template&id=7a2eb00e&"
import script from "./_document.vue?vue&type=script&lang=js&"
export * from "./_document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LegalDocument: require('/opt/render/project/src/channels2022/src/components/legal/LegalDocument.vue').default})
